export class ExtendedError extends Error {
  constructor (error, info) {
    super()
    this.id = error.response ? error.response.data.reason : (error.message || error.id || error.key || error)
    this.defaultMessage = error.defaultMessage
    this.values = error.values
    this.info = info
    this.name = this.constructor.name
  }
}
